import { createEntitySchemas } from '../../../utils/normalize'
import { format } from 'date-fns'

const formatDate = dateStr => dateStr ? format(new Date(dateStr), 'dd/MM/yyyy') : dateStr

export const DATA = 'organizationData'
export const dataSchemas = createEntitySchemas(DATA, {
  options: {
    processStrategy: entity => ({
      ...entity,
      constitution: formatDate(entity.constitution)
    })
  }
})
